// src/models/experienceFlow/default.ts
const buildExperienceFlowDefaultParams = () => {
	return {
		empty: null,
		sponsorScreenAfterClassSelection: false
	};
};

export { buildExperienceFlowDefaultParams };
//# sourceMappingURL=default.mjs.map